import React from "react";

export default function ImportLinks() {
  return (
    <div className="ImportLinks">
      <link
        href="https://fonts.googleapis.com/css?family=Architects+Daughter|Nanum+Gothic+Coding&display=swap"
        rel="stylesheet"
      />
    </div>
  );
}
